import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Firebase, Game } from '../../../Core'

import { FormattedMessage } from 'react-intl'

import * as selectors from '../mining.selectors'
import * as indicatorsSelectors from '../../Indicators/indicators.selectors'
import * as quizzesSelectors from '../../Quizzes/quizzes.selectors'

import * as actions from '../mining.actions'
import * as quizzesActions from '../../Quizzes/quizzes.actions'

import IndicatorContainer from '../../Indicators/IndicatorContainer'
import SessionCounter from '../../Components/SessionCounter'
import PointsAlert from '../../PointsManager/PointsAlert'
import BasicToast from '../../Toast/BasicToast'
import DocumentsButton from '../../Documents/DocumentsButton/index'
import SettingsMenuButton from '../../Settings/SettingsMenuButton'
import HelpButton from '../../Settings/HelpButton'
import UIButton from '../../UI/UIButton'
import UserShield from '../../Components/UserShield'
import MapButton from '../../Map/MapButton'

/**
 *  Pop up showed when you have finished the game
 */
class MiningScreensContainer extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      growOutClass: '',
    }
  }

  continueToMine() {
    const {
      clearFeedBack,
      removeQuestion,
      removeVoteQuestion,
      currentVoteQuestion,
      changeMiningScreen,
    } = this.props

    clearFeedBack()
    currentVoteQuestion
      ? changeMiningScreen('dispute_question_list')
      : changeMiningScreen('mining_default')
    removeQuestion(null)
    removeVoteQuestion(null)
  }

  componentWillUnmount() {
    const { removePrevScreen } = this.props
    removePrevScreen()
  }

  removeScreen() {
    const { changeMiningScreen, clearFeedBack, removeScreen, removeQuestion, removeVoteQuestion } =
      this.props

    this.setState({ growOutClass: 'bounceOut-animation' })
    setTimeout(() => {
      removeScreen('mining_screen')
      clearFeedBack()
      changeMiningScreen('mining_default')
      removeQuestion(null)
      removeVoteQuestion(null)
    }, 1000)
  }

  render() {
    const { screens, currentUser, components, miningScreen, groupData, userData, indicators } =
      this.props
    const { growOutClass } = this.state
    if (!miningScreen) {
      return
    }
    const component = screens[miningScreen].component
    const Viewer = components[component]

    const BackButton = ({ onClick, show }) => (
      <div className={`position--absolute left top ${!show ? 'display--none' : ''}`}>
        <div onClick={() => onClick()}>
          <div className="btn--back">
            <span className="icon-back"></span>
          </div>
        </div>
      </div>
    )

    // eslint-disable-next-line no-unused-vars
    const CloseButton = ({ removeScreen }) => (
      <UIButton
        icon={'icon-colonia'}
        id={'colony'}
        position={'position--absolute right bottom z-index1'}
        action={() => {
          removeScreen('mining_screen')
        }}
      />
    )
    const ColonyShield = ({ currentUser }) => (
      <div>
        <UserShield shield={currentUser.colonyShield} />
        <div className="player--position">
          <div className="player--label">
            <FormattedMessage id="ranking.position" defaultMessage="position" />
          </div>
          <div className="player--position__item">{currentUser.position}º</div>
        </div>
      </div>
    )

    return (
      <div
        className={`container ${growOutClass} ${
          !growOutClass ? 'growIn-animation' : ''
        } background background--mina z-index1`}
      >
        <PointsAlert />
        <BasicToast />
        <div className="content">
          <div className="mina fase-2 background--mina__canvas">
            <ColonyShield currentUser={currentUser} />
            <Viewer />
            {/* HUD BUTTONS */}
            <IndicatorContainer
              indicators={indicators}
              isVisitor={false}
              position="position--absolute center top z-index5"
            ></IndicatorContainer>
            <DocumentsButton />
            <SettingsMenuButton />
            <HelpButton />
            <MapButton action={() => this.removeScreen()} />
            <BackButton
              show={miningScreen !== 'mining_default'}
              onClick={() => this.continueToMine()}
            />

            <SessionCounter
              dateTime={groupData.endSessionDate}
              turn={userData.turn}
              maxTurns={groupData.maxTurns}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
  changeMiningScreen: bindActionCreators(actions.changeMiningScreen, dispatch),
  removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
  clearFeedBack: bindActionCreators(quizzesActions.clearFeedBack, dispatch),
  removeQuestion: bindActionCreators(quizzesActions.setQuestion, dispatch),
  removeVoteQuestion: bindActionCreators(quizzesActions.setVoteQuestion, dispatch),
  removePrevScreen: bindActionCreators(actions.removePrevScreen, dispatch),
})

const mapStateToProps = (state) => ({
  components: Game.selectors.getModuleComponents(state),
  miningScreen: selectors.getCurrentMiningScreen(state),
  currentUser: Firebase.selectors.getUserData(state),
  screens: selectors.getAllMiningScreens(state),
  currentVoteQuestion: quizzesSelectors.getVoteQuestion(state),
  groupData: Firebase.selectors.getGroupData(state),
  userData: indicatorsSelectors.getUserData(state),
  indicators: indicatorsSelectors.getIndicators(state),
  prevScreen: selectors.getPrevScreen(state),
})

MiningScreensContainer.propTypes = {
  changeMiningScreen: PropTypes.func,
  removePrevScreen: PropTypes.func,
  screens: PropTypes.object,
  currentUser: PropTypes.object,
  components: PropTypes.object,
  groupData: PropTypes.object,
  miningScreen: PropTypes.string,
  removeScreen: PropTypes.func,
  userData: PropTypes.object,
  currentVoteQuestion: PropTypes.object,
  indicators: PropTypes.array,
  clearFeedBack: PropTypes.func,
  removeQuestion: PropTypes.func,
  removeVoteQuestion: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MiningScreensContainer))
